
import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section 
      id="home"
      className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-r from-purple-600/20 via-blue-600/10 to-purple-600/20"></div>
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-30" style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/47c7ad8cc38cb6658c8a4e5f6c2dac12.jpg')`
      }}></div>
      
      <div className="relative max-w-7xl mx-auto px-6 text-center">
        <div className="inline-block bg-purple-600/20 border border-purple-400/30 text-purple-200 px-6 py-2 rounded-full mb-8 text-lg font-semibold">
          🚀 Revolutionary AI-Powered Interactive Entertainment Platform
        </div>
        
        <h1 className="text-5xl lg:text-7xl font-bold text-white mb-8 leading-tight">
          Next-Generation AI-Driven
          <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-blue-400">
            Interactive Entertainment Ecosystem
          </span>
        </h1>
        
        <p className="text-xl lg:text-2xl text-white/90 mb-12 max-w-4xl mx-auto leading-relaxed">
          Stratava AI is dedicated to creating revolutionary social gaming experiences that merge artificial intelligence, 
          creative expression, and community interaction, providing unlimited entertainment possibilities and immersive 
          digital worlds for users worldwide.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-16">
          <Button size="lg" className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white px-8 py-4 text-lg">
            <i className="ri-rocket-line mr-2"></i>
            Explore Our Products
          </Button>
          <Button size="lg" variant="outline" className="border-white/30 text-white hover:bg-white/10 px-8 py-4 text-lg">
            <i className="ri-play-circle-line mr-2"></i>
            Watch Demo
          </Button>
        </div>
        
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 max-w-2xl mx-auto">
          <h3 className="text-2xl font-bold text-white mb-4">🎮 Revolutionary Experience in Development</h3>
          <p className="text-white/80 text-lg">
            We are building the most advanced AI-driven social sandbox game that integrates creativity, gaming, 
            and AI interaction, bringing users unprecedented entertainment experiences.
          </p>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-6 flex items-center justify-center cursor-pointer">
          <i className="ri-arrow-down-line text-white text-2xl"></i>
        </div>
      </div>
    </section>
  );
}
